
// ---BT-107433_SrikanthRao_16-08-2023_Option Calculator || Functional Implementation

import { _optionChainShowCalculate } from "../optionChain";
import config from '../../config.json';
import apiCall from "../../apis/axios_instance";
import { getDistinctExpiry } from "../../apis";
import { BUSINESS_LAYER_RESPONSE } from "../../utils/global_variables";
const { TenantId } = config;
function _fn_NormalDensityFunction(nVal) {
    let result = 0.39894228040133 * Math.exp(-nVal * nVal / 2);
    return result;
}



function _fn_StdNormal(nX) {
    try {
        let lnResult;
        if (nX < -7.0)
            lnResult = _fn_NormalDensityFunction(nX) / (Math.sqrt(1.0 + nX * nX));
        else if (nX > 7.0)
            lnResult = 1.0 - _fn_StdNormal(-nX);
        else {
            lnResult = 0.2316419;
            let nNormalValues = [0.31938153, -0.356563782, 1.7814477937, -1.8212255978, 1.330274429];
            lnResult = 1.0 / (1 + lnResult * Math.abs(nX));
            lnResult = 1 - _fn_NormalDensityFunction(nX) * (lnResult * (nNormalValues[0] +
                lnResult * (nNormalValues[1] +
                    lnResult * (nNormalValues[2] +
                        lnResult * (nNormalValues[3] +
                            lnResult * (nNormalValues[4]))))));
            if (nX <= 0.0)
                lnResult = 1.0 - lnResult;
        }
        return lnResult;

    } catch (e) {
        console.log('error', e);
    }
}
export function _showcalculate(obj, DaysDiff, toggleOptionBtn, HUNDRED_FLOAT, Steps, bCalcImpVol, bAmerican) {

    // let nDaysUntilExpiration = dateDiffernece(obj.expiryOrContractDays);
    // let nDaysUntilExpiration = obj.expiryOrContractDays.nDayDiff;
    let nDaysUntilExpiration = DaysDiff;
    //BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - Start
    let nIndexPrice = parseFloat(obj.spotPrice);
    let nStrikePrice = parseFloat(obj.strikePrice);
    //BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - End
    let nInterestRate = obj.interestRate;
    let pVolatility = obj.volatility;
    let nOption = toggleOptionBtn;
    let nCall = 0.0;
    let nPut = 0.0;
    let nDividentYield = obj.dividend;
    let nMethod = obj.calculationMethod.USDOREUR;





    try {
        let nGammaCall, nGammaPut, nThetaCall, nThetaPut, nVegaCall, nVegaPut, nRhoCall, nRhoPut, nDeltaCall, nDeltaPut, nTheoCall, nTheoPut;
        let lnCall, lnPut, lnIndexPrice, lnStrikePrice, lnVolatility, lnInterestRate, lnDaysUntilExpiry, lnDividentYield;
        let nActualMarketPrice = 0.0;
        let lnD1, lnD2;

        lnIndexPrice = nIndexPrice;
        lnStrikePrice = nStrikePrice;
        lnInterestRate = nInterestRate / HUNDRED_FLOAT;
        lnInterestRate = nInterestRate / 100.00;
        lnDaysUntilExpiry = nDaysUntilExpiration / 365.0;
        lnVolatility = parseFloat((pVolatility)) / HUNDRED_FLOAT;
        lnVolatility = parseFloat((pVolatility)) / 100.00;
        let lnExponential = Math.exp((-lnInterestRate) * lnDaysUntilExpiry);
        let lnNaturalLog = Math.log(lnIndexPrice / lnStrikePrice);
        let lnVolatilitySq = Math.pow(lnVolatility, 2);
        let lnSqrtDaysUntilExpiry = Math.pow(lnDaysUntilExpiry, 0.5);

        let objResp = _optionChainShowCalculate(nIndexPrice, nStrikePrice, nInterestRate, nDaysUntilExpiration, pVolatility, nOption, nDividentYield, nCall, nPut);
        if (objResp?.data) {
            nTheoCall = objResp?.data.nTheoCall;
            nTheoPut = objResp?.data?.nTheoPut;
            nDeltaCall = objResp?.data?.nDeltaCall;
            nDeltaPut = objResp?.data?.nDeltaPut;
            nGammaCall = objResp?.data?.nGammaCall;
            nGammaPut = objResp?.data?.nGammaPut;
            nThetaCall = objResp?.data?.nThetaCall;
            nThetaPut = objResp?.data?.nThetaPut;
            nVegaCall = objResp?.data?.nVegaCall;
            nVegaPut = objResp?.data?.nVegaPut;
            nRhoCall = objResp?.data?.nRhoCall;
            nRhoPut = objResp?.data?.nRhoPut;
            nActualMarketPrice = objResp?.data?.nActualMarketPrice;

        } else {
            //Divident is not 0.Adjust for Divident
            lnDividentYield = nDividentYield / HUNDRED_FLOAT;
            let lnDividentExpo = Math.exp((-lnDividentYield) * lnDaysUntilExpiry);
            let lnDivAdjustedIndexPrice = lnIndexPrice * lnDividentExpo;
            lnD1 = ((lnNaturalLog) + (lnInterestRate - lnDividentYield + (lnVolatilitySq / 2)) * lnDaysUntilExpiry) / lnVolatility / lnSqrtDaysUntilExpiry;
            lnD2 = lnD1 - lnVolatility * lnSqrtDaysUntilExpiry;

            let lnStdNormalD1 = _fn_StdNormal(lnD1);
            let lnStdNormalD2 = _fn_StdNormal(lnD2);


            lnCall = lnDivAdjustedIndexPrice * lnStdNormalD1 - lnStrikePrice * lnExponential * lnStdNormalD2;

            lnPut = lnStrikePrice * lnExponential * (1 - lnStdNormalD2) - lnDivAdjustedIndexPrice * (1 - lnStdNormalD1);

            //if (double.IsInfinity(lnCall) === false)
            //        lnCall = 0;
            //if (double.IsInfinity(lnPut) == false)
            //        lnPut = 0;


            let lpFormatedCall;
            let lpFormatedPut;
            lpFormatedCall = lnCall.toFixed(4);
            lpFormatedPut = lnPut.toFixed(4);
            //**
            nCall = lpFormatedCall;
            nPut = lpFormatedPut;

            let lnDeltaCall, lnDeltaPut;
            let lpFormatedDeltaCall;
            let lpFormatedDeltaPut;
            lnDeltaCall = lnDividentExpo * lnStdNormalD1;
            //lnDeltaPut	= lnDividentExpo * lnStdNormalD1 - 1;
            lnDeltaPut = lnDeltaCall - 1;
            lpFormatedDeltaCall = lnDeltaCall.toFixed(4);
            lpFormatedDeltaPut = lnDeltaPut.toFixed(4);
            nDeltaCall = parseFloat(lpFormatedDeltaCall);
            nDeltaPut = parseFloat(lpFormatedDeltaPut);

            let lnNormalPdfD1 = Math.exp(-Math.pow(lnD1, 2) / 2) / 2.507132680972429;//Math.sqrt(2 * 3.14285714);

            let lnGammaCall, lnGammaPut;
            let lpFormatedGammaCall;
            let lpFormatedGammaPut;
            lnGammaCall = lnNormalPdfD1 * lnDividentExpo / (lnDivAdjustedIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
            lnGammaPut = lnNormalPdfD1 * lnDividentExpo / (lnDivAdjustedIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
            lpFormatedGammaCall = lnGammaCall.toFixed(4);
            lpFormatedGammaPut = lnGammaPut.toFixed(4);
            nGammaCall = parseFloat(lpFormatedGammaCall);
            nGammaPut = parseFloat(lpFormatedGammaPut);

            let lnVegaCall, lnVegaPut;
            let lpFormatedVegaCall;
            let lpFormatedVegaPut;
            lnVegaCall = lnDivAdjustedIndexPrice * lnSqrtDaysUntilExpiry * lnNormalPdfD1 * lnDividentExpo;
            lnVegaPut = lnDivAdjustedIndexPrice * lnSqrtDaysUntilExpiry * lnNormalPdfD1 * lnDividentExpo;;

            lnVegaCall = lnVegaCall / 100.0;
            lpFormatedVegaCall = lnVegaCall.toFixed(4);
            lnVegaPut = lnVegaPut / 100.0;
            lpFormatedVegaPut = lnVegaPut.toFixed(4);

            nVegaCall = parseFloat(lpFormatedVegaCall);
            nVegaPut = parseFloat(lpFormatedVegaPut);

            let lnThetaCall, lnThetaPut;
            let lpFormatedThetaCall;
            let lpFormatedThetaPut;
            lnThetaCall = -((lnDivAdjustedIndexPrice * lnNormalPdfD1 * lnVolatility * lnDividentExpo / 2 / lnSqrtDaysUntilExpiry))
                + (lnDividentYield * lnDivAdjustedIndexPrice * lnStdNormalD1 * lnDividentExpo)
                - (lnInterestRate * lnStrikePrice * lnExponential * lnStdNormalD2);

            lnThetaPut = -(lnDivAdjustedIndexPrice * lnNormalPdfD1 * lnVolatility * lnDividentExpo) / 2.0 / lnSqrtDaysUntilExpiry
                - (lnDividentYield * lnDivAdjustedIndexPrice * (1 - lnStdNormalD1) * lnDividentExpo)
                + (lnInterestRate * lnStrikePrice * lnExponential * (1 - lnStdNormalD2));

            lnThetaCall = lnThetaCall / 365.0;
            lpFormatedThetaCall = lnThetaCall.toFixed(4);
            lnThetaPut = lnThetaPut / 365.0;
            lpFormatedThetaPut = lnThetaPut.toFixed(4);

            nThetaCall = parseFloat(lpFormatedThetaCall);
            nThetaPut = parseFloat(lpFormatedThetaPut);

            let lnRhoCall, lnRhoPut;
            let lpFormatedRhoCall;
            let lpFormatedRhoPut;
            lnRhoCall = lnStrikePrice * lnDaysUntilExpiry * lnExponential * lnStdNormalD2;
            lnRhoPut = -lnStrikePrice * lnDaysUntilExpiry * lnExponential * (1 - lnStdNormalD2);
            lnRhoCall = lnRhoCall / 100.0;
            lpFormatedRhoCall = lnRhoCall.toFixed(4);
            lnRhoPut = lnRhoPut / 100.0;
            lpFormatedRhoPut = lnRhoPut.toFixed(4);
            nRhoCall = parseFloat(lpFormatedRhoCall);
            nRhoPut = parseFloat(lpFormatedRhoPut);

            nTheoCall = nCall;
            nTheoPut = nPut;

            if (bCalcImpVol === true) {
                if (nOption === 0) {
                    nActualMarketPrice = nCall;
                }
                if (nOption === 1) {
                    nActualMarketPrice = nPut;
                }
            }
        }


        if (nMethod === 0 && nDaysUntilExpiration > 0) {
            // fn_ActualBinomialCalculation(Steps);
            try {
                let T = nDaysUntilExpiration / 365.0;
                let n = (Steps === 0) ? (parseInt(nDaysUntilExpiration) * 2) : parseInt(Steps); // used for precision
                let OptionValueC = [];
                let OptionValueP = [];


                let b = (nInterestRate / HUNDRED_FLOAT) - nDividentYield; //dCOC;
                let r = (nInterestRate / HUNDRED_FLOAT);
                let S = nIndexPrice;
                let X = nStrikePrice;

                let v = pVolatility / HUNDRED_FLOAT;

                let z = 1;

                let dt = T / n;
                let u = Math.exp(v * Math.pow(dt, 0.5));
                let q = 1 / u;
                let p = (Math.exp(b * dt) - q) / (u - q);
                let Df = Math.exp(-r * dt);


                for (let i = 0; i <= n; i++) {
                    let temp = z * (S * Math.pow(u, i) * Math.pow(q, n - i) - X);
                    OptionValueC[i] = Math.max(0, temp);
                    OptionValueP[i] = Math.max(0, (-1) * temp);

                }

                for (let j = n - 1; j >= 0; j--)
                    for (let i = 0; i <= j; i++) {
                        if (bAmerican === false) {
                            OptionValueC[i] = (p * OptionValueC[i + 1] + (1 - p) * OptionValueC[i]) * Df;
                            OptionValueP[i] = (p * OptionValueP[i + 1] + (1 - p) * OptionValueP[i]) * Df;
                        }
                        else {
                            let x1 = (z * (S * Math.pow(u, i) * Math.pow(q, Math.abs(i - j)) - X));
                            let x2 = (p * OptionValueC[i + 1] + (1 - p) * OptionValueC[i]) * Df;
                            let x3 = (p * OptionValueP[i + 1] + (1 - p) * OptionValueP[i]) * Df;
                            OptionValueC[i] = Math.max(x1, x2);
                            OptionValueP[i] = Math.max(x1 * (-1), x3);

                        }
                    }

                nCall = OptionValueC[0];
                nPut = OptionValueP[0];

                nTheoCall = (Math.round(nCall * 10000)) / 10000;
                nTheoCall = nTheoCall.toString();
                let strTheo = nTheoCall;
                if (strTheo.indexOf(".") === -1) {
                    nTheoCall += ".0000";
                }
                nPut = nPut.toString();
                if (nPut.indexOf(".") === -1) {
                    nPut += ".0000";
                }
                nTheoPut = nPut;

                if (isFinite(nCall) === false)
                    nCall = 0;
                if (isFinite(nPut) === false)
                    nPut = 0;
            } catch (error) {
                console.log("fn_ActualBinomialCalculation");
            }
        }
        if (isFinite(nTheoCall.toString()) === false) {
            nTheoCall = 0;
        }
        //  else { _selfOptionVal.MarketVal(nTheoPut); }
        if (isFinite(nTheoPut.toString()) === false) {
            nTheoPut = 0;
        }
        //  else { _selfOptionVal.MarketVal(nTheoCall); }
        let ObjCalculate = {
            nCallTheoretical: nTheoCall,
            nPutTheoretical: nTheoPut,
            nCallDelta: nDeltaCall,
            nPutDelta: nDeltaPut,
            nCallGamma: nGammaCall,
            nPutGamma: nGammaPut,
            nCallTheta: nThetaCall,
            nPutTheta: nThetaPut,
            nCallVega: nVegaCall,
            nPutVega: nVegaPut,
            nCallRho: nRhoCall,
            nPutRho: nRhoPut,
            MarketVal: nActualMarketPrice?.toString()
        };
        return ObjCalculate;
    } catch (error) {
        console.log('error', error);
    }
}

// -------------------------validation---------------------------start


export const _validateOptionValues = (obj, arrStrikePriceOption, DaysDiff) => {


    let objValidateWarnings = {
        contract: false,
        spotPrice: false,
        strikePrice: false,
        interestRate: false,
        volatility: false,
        dividend: false,
        calculate: false,
    };
    try {

        // let DaysUntilExpiration = parseFloat(_dateDiffernece(obj.expiryOrContractDays));
        //  let DaysUntilExpiration = obj.expiryOrContractDays.nDayDiff;
        let DaysUntilExpiration = DaysDiff; //ManasaB : 26-03-2024 : Changed after discussion with Srikanth for contract validation

        if (DaysUntilExpiration === undefined || DaysUntilExpiration == null) {
            objValidateWarnings.contract = true;


        };

        if (DaysUntilExpiration <= 0 || DaysUntilExpiration > 1800) {
            objValidateWarnings.contract = true;

        };

        if (arrStrikePriceOption?.length > 0) {
            if (obj.strikePrice === undefined || obj.strikePrice == null || obj.strikePrice <= 0) {
                objValidateWarnings.strikePrice = true;
            }
        }
        else {
            if (isNaN(obj.strikePrice)) {
                objValidateWarnings.strikePrice = true;
            }

            if (obj.strikePrice < 0.0001 || obj.strikePrice > 99999.9999) {
                objValidateWarnings.strikePrice = true;

            }
        }
        // if (obj.spotPrice === 0) {
        //     objValidateWarnings.spotPrice = true;
        // }

        if (obj.spotPrice <= 0 || obj.spotPrice > 99999.9999) {
            objValidateWarnings.spotPrice = true;

        }

        if (isNaN(obj.interestRate)) {
            objValidateWarnings.interestRate = true;


        }

        if (obj.interestRate < 0.01 || obj.interestRate > 99.99) { //BT-107433 Calculator - ManasaB : 22-03-2024 : SAT 2 Issues :Changed as per BA comments
            objValidateWarnings.interestRate = true;

        }

        if (isNaN(obj.volatility)) {
            objValidateWarnings.volatility = true;

        }

        if (obj.volatility < 0.01 || obj.volatility > 999.99) {//BT-107433 Calculator - ManasaB : 22-03-2024 : SAT 2 Issues :Changed as per BA comments
            objValidateWarnings.volatility = true;



        }

        if (obj.dividend < 0 || obj.dividend > 99.99 || obj.dividend.length === 0) {//BT-107433 Calculator - ManasaB : 22-03-2024 : SAT 2 Issues :Changed as per BA comments
            objValidateWarnings.dividend = true;

        }

        if (isNaN(obj.dividend)) {
            objValidateWarnings.dividend = true;

        }

        // ---for future use-----
        // if ((objValidateWarnings.contract && objValidateWarnings.spotPrice && objValidateWarnings.strikePrice && objValidateWarnings.interestRate && objValidateWarnings.volatility && objValidateWarnings.dividend)) {
        //     objValidateWarnings.calculate(false);
        // } else {
        //     objValidateWarnings.calculate(true);
        // }

        // if (originalList.length > 0) {
        //     let expirypresent = false;
        //     for (let counter = 0; counter < originalList.length; counter++) {
        //         let covertedDate = originalList[counter].Date.substr(0, 2) + ' ' + originalList[counter].Date.substr(2, 3) + ' ' + "'" + originalList[counter].Date.substr(-2);
        //         if (covertedDate == expiryDate) {
        //             expirypresent = true;
        //         }
        //     }

        //     if (!expirypresent) {
        //         // showAlert('Enter Proper Expiry in Contract Days');
        //         return false;
        //     }
        // }



        return objValidateWarnings;

    } catch (error) {
        console.log("error", error);

    }

};
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - Start
export const _fetchExpStrikeOptionalValue = async (objPayload) => {
    try {
        let objResponse = await getDistinctExpiry(objPayload.symbol, '');
        let arrDatesResponse = objResponse.data.result.hits.hits;
        let arrDistinctExpDates = arrDatesResponse.map(eachResp => eachResp["_source"].nExpiryDate1);
        const filterDulicateDate = (arrDates) => {
            let arrUniqueDates = new Set();
            return arrDates.filter(eachObj => {
                if (!arrUniqueDates.has(eachObj)) {
                    arrUniqueDates.add(eachObj);
                    return true;
                }
                return false;
            });
        };
        const arrFilteredDates = filterDulicateDate(arrDistinctExpDates);
        let objOptionChainData = await apiCall.get(`/nontransactional/${TenantId}/v1/getScripFromInstrumentAndExchange/null/${objPayload.expiryDate}/${objPayload.symbol}/813746271`);
        let arrSelectedOptionContractData = objOptionChainData?.data?.result?.hits?.hits;
        let arrStrikePrice = arrSelectedOptionContractData.map(eachObj => eachObj["_source"].nStrikePrice1);
        const filterDuplicateStrikePrice = (arrStrikes) => {
            let arrUniqueStrikePrice = new Set();
            return arrStrikes.filter(eachPrice => {
                if (eachPrice) {
                    if (!arrUniqueStrikePrice.has(eachPrice)) {
                        arrUniqueStrikePrice.add(eachPrice);
                        return true;
                    }
                    return false;
                }

            });
        };
        const arrFinalFilteredStrikePrice = filterDuplicateStrikePrice(arrStrikePrice);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrStrikePrice: arrFinalFilteredStrikePrice, arrExpiryDates: arrFilteredDates } };
    } catch (error) {
        console.log('error', error);
    }

};
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - End

// // -------------------------validation---------------------------end
// export function _getNumericMonth(sMonth) {
//     try {
//         let sRetval = "";
//         switch (sMonth) {
//             case "JAN":
//                 sRetval = "00";
//                 break;
//             case "FEB":
//                 sRetval = "01";
//                 break;
//             case "MAR":
//                 sRetval = "02";
//                 break;
//             case "APR":
//                 sRetval = "03";
//                 break;
//             case "MAY":
//                 sRetval = "04";
//                 break;
//             case "JUN":
//                 sRetval = "05";
//                 break;
//             case "JUL":
//                 sRetval = "06";
//                 break;
//             case "AUG":
//                 sRetval = "07";
//                 break;
//             case "SEP":
//                 sRetval = "08";
//                 break;
//             case "OCT":
//                 sRetval = "09";
//                 break;
//             case "NOV":
//                 sRetval = "10";
//                 break;
//             case "DEC":
//                 sRetval = "11";
//                 break;
//             default:
//                 break;
//         }
//         return sRetval;

//     } catch (e) {
//         console.log("error", e);
//     }
// }
// export function _dateDiffernece(inputdate) {
//     try {
//         let day = parseInt(inputdate.substr(0, 2));
//         let month = parseInt(_getNumericMonth(inputdate.substr(2, 3))) + 1;
//         month = month < 10 ? "0" + month.toString() : month;
//         let year = parseInt(inputdate.substr(-4));
//         let newDate = month + '/' + day + '/' + year + ' ' + '00' + ':' + '00' + ':' + '00';
//         let nextdate = new Date(newDate);
//         let curruntData = new Date();
//         let diffTime = Math.abs(nextdate - curruntData);
//         let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//         return diffDays;
//     } catch (error) {
//         console.log("error", error);
//     }
// }

